import { AfterViewInit, Component, OnDestroy, OnInit } from '@angular/core';
import { CampaignReportPageService } from '../../services/campaign-report-page/campaign-report-page.service';
import { Subject } from 'rxjs';
import { RouteReuseStrategyService } from '../../services/route-reuse-strategy-service/route-reuse-strategy-service.service';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-report-transfers-page',
  templateUrl: './report-transfers-page.component.html',
  styleUrls: ['./report-transfers-page.component.scss']
})
export class ReportTransfersPageComponent implements OnInit, AfterViewInit, OnDestroy {

  private takeUntilSubject: Subject<any> = new Subject();
  private takeUntilRouteReuseStrategySubject: Subject<any> = new Subject();
  
  constructor(
    private routeReuseStrategyService: RouteReuseStrategyService,
    public campaignReportPageService: CampaignReportPageService
  ) {}

  ngOnInit(): void {
    this.routeReuseStrategyService.status = true;
    this.routeReuseStrategyService.routeReuseStrategySubject.pipe(
      takeUntil(this.takeUntilRouteReuseStrategySubject)
    ).subscribe(() => {
      this.takeUntilSubject.next(null);
      this.takeUntilSubject.complete();
      this.takeUntilSubject = new Subject();

      this.ngAfterViewInit();
    });
  }

  ngAfterViewInit(): void {

    const { campaignReportPageService } = this;

    window['$']('.datepicker').pickadate({
      formatSubmit: 'yyyy/mm/dd',
      closeOnSelect: true,
      closeOnClear: false,
      selectYears: true,
      selectMonths: true
  });
    window['orgMain'].showTransfers(
      { 
        startDate: campaignReportPageService.transStartDate,
        endDate: campaignReportPageService.transEndDate
      }
    )
  }

  ngOnDestroy(): void {
    this.campaignReportPageService.transStartDate = window["$"]("#transStartDatePicker").data("pickadate").get("select");
    this.campaignReportPageService.transEndDate = window["$"]("#transEndDatePicker").data("pickadate").get("select");

    window["$"]("#transfers").hide()
    window["$"]("#transfers").empty()

    this.takeUntilSubject.next(null);
    this.takeUntilSubject.complete();

    this.takeUntilRouteReuseStrategySubject.next(null);
    this.takeUntilRouteReuseStrategySubject.complete();

    this.routeReuseStrategyService.status = false;
  }

}
